<template>
  <div class="c-app" :class="$store.state.appColor ? $store.state.appColor : 'light_green'">
    <TheSidebar v-if="!siteLoading" :locale="locale"/>
    <TheAside v-if="!siteLoading"/>
    <socket-notifications v-if="!siteLoading && $store.state.user"></socket-notifications>
    <CWrapper v-if="!siteLoading">
      <TheHeader v-if="$store.state.user || configureRoute()" v-on:change-locale="changeLocale"/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view v-if="$store.state.user || configureRoute()"></router-view>
            </transition>
          </CContainer>
        </main>
        <!-- <TheFooter/> -->
        <demo-error-tools v-if="$store.state.user && demoErrorToolsEnabled" />
      </div>
    </CWrapper>
    <small-loader v-else></small-loader>

    <image-viewer v-if="$store.state.imageViewer"></image-viewer>
    <app-version v-if="!siteLoading"></app-version>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAside from './TheAside'
import SocketNotifications from './../views/components/socket_notifications'
import AppVersion from './../views/components/app_version'
import ImageViewer from './../views/components/image_viewer'
import DemoErrorTools from '@/components/DemoErrorTools'
import { demoErrorToolsEnabled } from '@/demoErrorToolsEnabled'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside,
    SocketNotifications,
    AppVersion,
    ImageViewer,
    DemoErrorTools
  },
  data(){
    return {
      locale: 'en',
      noArray: ['/register_user', '/new_password', '/forgot_password', '/login'],
      siteLoading: true,
      viewImages: [],
      index: null,
      demoErrorToolsEnabled: demoErrorToolsEnabled()
    }
  },
  mounted: function () {
    this.siteLoading = true
    var that = this
    if (window.localStorage.getItem('app_color')) {
      var obj = {
        local: 'app_color',
        type: 'appColor',
        value: window.localStorage.getItem('app_color')
      }
      this.$store.commit("appSettingChanged", obj)
    }
    if (window.localStorage.getItem('locations_type')) {
      var obj = {
        local: 'locations_type',
        type: 'locationsType',
        value: window.localStorage.getItem('locations_type')
      }
      this.$store.commit("appSettingChanged", obj)
    }
    if (that.noArray.indexOf(this.$router.app._route.path) < 0) {
      axios.post(this.$apiAdress + '/api/refresh?token=' + localStorage.getItem('api_token'))
      .then(function (response) {
        localStorage.setItem("api_token", response.data.access_token);
        localStorage.setItem('roles', response.data.roles);
        setTimeout(function () {
          that.$store.commit('fetchUser')
          that.siteLoading = false
          that.viewImages = ["https://server.paiworkflow.com/volume/qXlOvL12bjP4tlKNAMkNnUksh7Noi9e9UyNs5jJd.jpeg"]
          that.index = 0
        }, 500)
      }).catch(function (e) {
        console.log('e')
        that.$router.push({name: 'Login', params: {nextUrl: that.$router.history.current.fullPath}})
        that.siteLoading = false
      })
    } else {
      that.siteLoading = false
    }
  },
  methods: {
    changeLocale(value){
      this.locale = value;
    },
    closeModal() {
      this.$store.commit('setImageViewer', false)
    },
    configureRoute() {
      var that = this
      if (that.noArray.indexOf(that.$router.app._route.path) >= 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
